import type { GraphQLClient } from "@core/utils/aws/appsync/GraphQLClient.js";
import type { CognitoClient } from "@core/utils/aws/cognito/CognitoClient.svelte.js";
import type { GlobalSettings } from "../contexts/GlobalSettings.js";

interface Clients {
	cognito: CognitoClient;
	graphQL: GraphQLClient;
}

let clients: Clients | undefined;

export async function getClients(globalSettings: GlobalSettings): Promise<Clients> {
	if (clients) {
		return clients;
	}

	if (typeof window === "undefined") {
		return {} as Clients;
	}

	const {
		AWS_REGION,
		AWS_USER_POOL_ID,
		AWS_IDENTITY_POOL_ID,
		AWS_USER_POOL_CLIENT_ID,
		PUBLIC_GRAPHQL_ENDPOINT,
		AWS_USER_POOL_DOMAIN,
	} = globalSettings;

	const [{ GraphQLClient }, { CognitoClient }] = await Promise.all([
		import("@core/utils/aws/appsync/GraphQLClient.js"),
		import("@core/utils/aws/cognito/CognitoClient.svelte.js"),
	]);

	let graphQL: GraphQLClient | undefined;
	const cognito = new CognitoClient(
		AWS_REGION,
		AWS_USER_POOL_CLIENT_ID,
		AWS_IDENTITY_POOL_ID,
		AWS_USER_POOL_ID,
		true,
		AWS_USER_POOL_DOMAIN,
		(credentialProvider) => {
			graphQL = new GraphQLClient(AWS_REGION, PUBLIC_GRAPHQL_ENDPOINT, credentialProvider, import.meta.env.DEV);
			if (clients) {
				clients.graphQL = graphQL;
			}
		},
	);
	if (!graphQL) {
		throw new Error("Clients not created");
	}

	return (clients ??= {
		cognito,
		graphQL,
	});
}
